import { Box } from '@material-ui/core';
import React from 'react';

import { Duo } from './duo';

export const ColorsWidget = () => {
  const colors = [
    { label: 'Свободен', color: '#181F28' },
    { label: 'Занят', color: '#1CBD91' },
    { label: 'Занят, без заказа', color: '#1CBD91', stripe: '#000000' },
    { label: 'Внимание', color: '#EAAA08' },
    { label: 'Опоздание', color: '#EA2727' },
    { label: 'Требуется действие', color: '#C62828', halfStripe: '#EA2727' },
    { label: 'Есть бронь', dot: '#EA2727' },
  ];

  return (
    <Box display="flex" flexDirection="row" gridColumnGap={24} gridRowGap={8} flexWrap="wrap">
      {colors.map((color) => {
        const style: React.CSSProperties = {};

        if (color.color) {
          style.background = color.color;
        }

        if (color.stripe) {
          style.background = `repeating-linear-gradient(
            -45deg,
            ${color.stripe} 0 4px,
            transparent 4px 8px
          ), ${color.color}`;
        }

        if (color.halfStripe) {
          style.background = `linear-gradient(
            135deg,
            ${color.halfStripe} 50%,
            ${color.color} 50%
          )`;
        }

        if (color.dot) {
          style.position = 'relative';
        }

        let element: React.ReactElement;
        if (color.dot) {
          element = (
            <Box
              width={18}
              height={18}
              style={style}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Box width={6} height={6} borderRadius="50%" bgcolor={color.dot} />
            </Box>
          );
        } else {
          element = <Box width={18} height={18} borderRadius={4} style={style} />;
        }

        return (
          <Duo
            key={color.label}
            first={element}
            second={
              <Box fontSize={14} color="rgb(70, 79, 92)">
                {color.label}
              </Box>
            }
            gridColumnGap={6}
            alignItems="center"
          />
        );
      })}
    </Box>
  );
};
